import { styled } from '@linaria/react';
import { Icon } from '../../../../ui-library/icon/icon';
import { getMentionTypeColor } from './flora-mention.helpers';
import { CATEGORY_ICONS, type MentionType } from './flora-mention.type';

interface MentionTagProps {
  mentionType: MentionType;
  name: string;
}

export const MentionTag = ({ mentionType, name }: MentionTagProps) => {
  const color = getMentionTypeColor(mentionType);

  return (
    <Tag style={{ backgroundColor: `${color}15`, color }}>
      <Icon name={CATEGORY_ICONS[mentionType]} color={color} size={13} />
      {name}
    </Tag>
  );
};

const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 1px 7px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
  vertical-align: baseline;
  white-space: nowrap;
`;
